import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function Datenschutz() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <img src="/images/logo.svg" alt="Logo" className="legal-logo" />
        <h1>Schulungsplattform</h1>
      </div>
      <div className="legal-content">
        <h2>Datenschutzerklärung</h2>

        <div className="legal-section">
          <h3>1. Datenschutz auf einen Blick</h3>
          <p>Diese Datenschutzerklärung informiert Sie über die Art, den Umfang und den Zweck der Verarbeitung personenbezogener Daten innerhalb unserer Schulungsplattform. Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
        </div>

        <div className="legal-section">
          <h3>2. Verantwortliche Stelle</h3>
          <p><strong>F&F AI Automation Services & Products UG (haftungsbeschränkt)</strong><br />
          Wannenstr. 14, 74842 Billigheim, Deutschland<br />
          Vertreten durch: Robin Fichter, Gabriel Frank<br />
          E-Mail: <a href="mailto:info@ff-ai-automation.de">info@ff-ai-automation.de</a></p>
        </div>

        <div className="legal-section">
          <h3>3. Erhobene Daten</h3>
          <p>Im Rahmen der Nutzung dieser Schulungsplattform werden folgende personenbezogene Daten verarbeitet:</p>
          <ul>
            <li>Name und E-Mail-Adresse (zur Identifikation und Kommunikation)</li>
            <li>Schulungsfortschritt und Testergebnisse (zur Ausstellung von Zertifikaten und Berichterstattung)</li>
            <li>Anmeldedaten (verschlüsselt gespeichert)</li>
            <li>Datum und Uhrzeit von Schulungsabschlüssen</li>
          </ul>
        </div>

        <div className="legal-section">
          <h3>4. Zweck der Datenverarbeitung</h3>
          <p>Die erhobenen Daten werden ausschließlich für folgende Zwecke verwendet:</p>
          <ul>
            <li>Bereitstellung und Verwaltung der Schulungsplattform</li>
            <li>Nachverfolgung des Schulungsfortschritts</li>
            <li>Ausstellung von Schulungszertifikaten</li>
            <li>Benachrichtigungen per E-Mail über Schulungsstatus und Fristen</li>
          </ul>
          <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).</p>
        </div>

        <div className="legal-section">
          <h3>5. Hosting</h3>
          <p>Diese Plattform wird bei IONOS SE gehostet. Bei jedem Zugriff werden Serverzugangsdaten gespeichert (IP-Adresse, Browsertyp, Betriebssystem, Datum/Uhrzeit). Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO. Ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO wurde abgeschlossen.</p>
        </div>

        <div className="legal-section">
          <h3>6. Datensicherheit</h3>
          <p>Die Übertragung Ihrer Daten erfolgt verschlüsselt über HTTPS (TLS). Passwörter werden niemals im Klartext gespeichert, sondern ausschließlich als gesicherter Hash (bcrypt). Der Zugriff auf personenbezogene Daten ist auf autorisierte Benutzer beschränkt.</p>
        </div>

        <div className="legal-section">
          <h3>7. Weitergabe von Daten</h3>
          <p>Eine Weitergabe Ihrer Daten an Dritte findet nicht statt, es sei denn, dies ist zur Vertragserfüllung notwendig oder Sie haben ausdrücklich eingewilligt. E-Mails werden über unseren SMTP-Dienstleister versendet.</p>
        </div>

        <div className="legal-section">
          <h3>8. Ihre Rechte</h3>
          <p>Sie haben folgende Rechte hinsichtlich Ihrer gespeicherten personenbezogenen Daten:</p>
          <ul>
            <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO): Recht auf Auskunft über Ihre gespeicherten Daten</li>
            <li><strong>Berichtigungsrecht</strong> (Art. 16 DSGVO): Recht auf Korrektur unrichtiger Daten</li>
            <li><strong>Löschungsrecht</strong> (Art. 17 DSGVO): Recht auf Löschung Ihrer Daten</li>
            <li><strong>Einschränkungsrecht</strong> (Art. 18 DSGVO): Recht auf Einschränkung der Verarbeitung</li>
            <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Recht auf Widerspruch gegen die Verarbeitung</li>
            <li><strong>Beschwerderecht</strong>: Recht auf Beschwerde bei der Datenschutzaufsichtsbehörde (LfDI Baden-Württemberg)</li>
          </ul>
          <p>Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: <a href="mailto:info@ff-ai-automation.de">info@ff-ai-automation.de</a></p>
        </div>

        <p className="legal-copy">© {new Date().getFullYear()} F&F AI Automation Services & Products UG</p>
      </div>
    </div>
  );
}
